import { useEffect, useState } from 'react';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';

const TOKEN_KEY = '@pwa:access-token';
const USER_KEY = '@pwa:user';

interface AuthUser {
  id?: string;
  name?: string;
  email?: string;
}

interface UseAuthReturn {
  accessToken: string;
  user: AuthUser | null;
  saveToken: (newToken: string) => void;
  saveUser: (newUser: AuthUser) => void;
  clearAuth: () => void;
  isAuthenticated: boolean;
}

export const useAuthStorage = (): UseAuthReturn => {
  const [accessToken, setAccessToken] = useState<string>('');
  const [user, setUser] = useState<AuthUser | null>(null);
  
  useEffect(() => {
    const storedToken = ApiLocalStorage.get(TOKEN_KEY);
    const storedUser = ApiLocalStorage.get(USER_KEY);
    
    if (storedToken) {
      setAccessToken(storedToken);
    }
    
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);
  
  const saveToken = (newToken: string) => {
    ApiLocalStorage.set(TOKEN_KEY, newToken);
    setAccessToken(newToken);
  };
  
  const saveUser = (newUser: AuthUser) => {
    ApiLocalStorage.set(USER_KEY, newUser);
    setUser(newUser);
  };
  
  const clearAuth = () => {
    ApiLocalStorage.remove(TOKEN_KEY);
    ApiLocalStorage.remove(USER_KEY);
    setAccessToken('');
    setUser(null);
  };
  
  return {
    accessToken,
    user,
    saveToken,
    saveUser,
    clearAuth,
    isAuthenticated: Boolean(accessToken)
  };
};
